import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-151b43d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    label: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "toggle"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("label", {
    class: "checkbox",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !_ctx.modelValue))),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle', !_ctx.modelValue)))
    }, null, 40, _hoisted_1),
    _createVNode(_component_Icon, {
      icon: "ic:round-check",
      class: _normalizeClass(["checkbox-icon", { checked: _ctx.modelValue }])
    }, null, 8, ["class"]),
    _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
  ]))
}
}

})